var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightOfferCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 205,
    viewBox: "0 0 342 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 327,
    height: 175
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40c0-15.464 12.536-28 28-28h275c13.255 0 24 10.745 24 24v127c0 13.255-10.745 24-24 24H28c-15.464 0-28-12.536-28-28V40z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.992 37.18c112.055 14.653 139.59-249.455 316.693-168.012C654.787-49.39 604.869 6.213 840.039 71.519 1075.21 136.827 1055.92 270.15 1059.82 316.4c3.89 46.251-780.808 15.989-780.808 15.989l-118.02-295.21z",
    fill: "url(#b)",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 314.308,
    y1: -0.978,
    x2: 232.545,
    y2: 103.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE",
    stopOpacity: 0.341
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BC231",
    stopOpacity: 0.09
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOfferCard);
export default __webpack_public_path__ + "static/media/lightOfferCard.c6ed640b15c1ee621f63f47568ce9c45.svg";
export { ForwardRef as ReactComponent };